import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectUserLanguage } from '../../authentication/store/user.selector';
import { take } from 'rxjs';
import { WidgetComponent } from '../widget/widget.component';
import { MatIcon } from '@angular/material/icon';
import { PrimaryButtonComponent } from '../../shared/buttons/primary-button.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'sibat-checklist-dashboard',
  templateUrl: './checklist.component.html',
  styleUrls: ['checklist.component.scss'],
  imports: [WidgetComponent, MatIcon, PrimaryButtonComponent, TranslocoPipe],
})
export class ChecklistComponent {
  constructor(private store: Store) {}

  open(ext: string): void {
    this.store
      .select(selectUserLanguage)
      .pipe(take(1))
      .subscribe(lang => {
        const safeLang = ['fr', 'de'].includes(lang ?? '') ? lang : 'fr';

        const filePath = `assets/checklist/Check-list-SCPI-SIBAT-${safeLang}.${ext}`;
        this.triggerOpen(filePath);
      });
  }

  private triggerOpen(path: string): void {
    const a = document.createElement('a');
    a.href = path;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
    a.remove();
  }
}
